// removed by extract-text-webpack-plugin
module.exports = {"labelContainer":"_2dN6LPpwTF0sh8mRYNdDES","label":"_2agn-TQC_6JhMxRSGBzktV"};


/*****************
 ** WEBPACK FOOTER
 ** ./client/form/Label.css
 ** module id = 788
 ** module chunks = 0 1
 **/